.wrapper {
  position: relative;
  display: block;
  width: 100%;
}

/* Deliberately the same box as Select's: the two sit side by side, and a
   control that opens a panel instead of a menu is still the same kind of
   thing to the person choosing with it. */
.trigger {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: var(--touch-target);
  padding: 0 var(--space-3);
  background: var(--surface-raised);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: var(--text-base);
  text-align: left;
  cursor: pointer;
  transition: border-color var(--duration-fast) var(--ease-out);
}

.trigger:hover {
  border-color: var(--text-muted);
}

.summary {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chevron {
  flex: none;
  width: var(--space-4);
  height: var(--space-4);
  color: var(--text-muted);
}

.panel {
  position: absolute;
  top: calc(100% + var(--space-1));
  right: 0;
  left: 0;
  z-index: var(--z-overlay);
  max-height: var(--measure-card);
  padding: 0 var(--space-3);
  overflow-y: auto;
  background: var(--surface-overlay);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
}

.option {
  display: flex;
  width: 100%;
}

.option + .option {
  border-top: 1px solid var(--border);
}
